import z from "zod"

export const TABLE_CONTEXT_MAP = {
  AGEC: "agec",
  LCA: "lca",
  BUSINESS_PARTNERS_REPOSITORY: "businessPartnersRepository",
  BUSINESS_PARTNERS_PRODUCTION_SITES: "businessPartnersProductionSites",
  CERTIFICATES_ALL: "certificatesAll",
  CERTIFICATES_SCOPE: "certificatesScope",
  CERTIFICATES_TRANSACTION: "certificatesTransaction",
  DATA_TRANSFER_IMPORT: "dataHubImport",
  PRODUCTS_CATALOG: "productsCatalog",
  PRODUCTS_CUSTOM_FIELDS: "customFields",
  PRODUCTS_CERTIFICATES: "certificates",
  PRODUCTS_TRACEABILITY: "traceability",
  SUPPLIERS: "suppliers",
  SUB_SUPPLIERS: "subSuppliers",
} as const

export const tableContextSchema = z.enum(Object.values(TABLE_CONTEXT_MAP))

export type TableContext = z.infer<typeof tableContextSchema>
